import { sportIdMapConfig } from "../config";
export const getScoreLabels = (sportId, scores, dict, homeScore, awaysScore) => {
    var _a;
    if (scores.length || homeScore || awaysScore) {
        const scoreLabels = scores.map((el, index) => (index + 1).toString());
        const extraScoreLabelsKeys = ((_a = sportIdMapConfig[sportId]) === null || _a === void 0 ? void 0 : _a.labelsKeys) || ["Total"];
        const extraScoreLabels = extraScoreLabelsKeys.map(key => dict.myBetsDictionary[key] || "");
        return [...scoreLabels, ...extraScoreLabels];
    }
    return [];
};
//# sourceMappingURL=getScoreLabels.js.map